import { toast } from 'react-hot-toast';

export const toastAlert = (variant: 'success' | 'error', message: string) => {
  const toastOptions = {
    style: {
      zIndex: 10000, // Ensure this is higher than the modal's z-index
    },
  };

  if (variant === 'success') {
    return toast.success(message, toastOptions);
  } else if (variant === 'error') {
    return toast.error(message, toastOptions);
  } else {
    return null;
  }
};
